import styled from '@emotion/styled';
import Paper from '@base/Paper/Paper';
import Skeleton from '@material-ui/lab/Skeleton';
import HeaderNavBar from '@skeletons/HeaderNavBar/HeaderNavBar';
import { Spacings, mediaQuery } from '@styles/index';
import { useIsMobile } from '@stores/AppCommonData';
import Actions from './Actions';

const Container = styled(Paper)`
  grid-column: span 24 / auto;
  padding: 32px 48px;
`;

const Breadcrumbs = styled(HeaderNavBar)`
  padding: 0;
`;

const Flex = styled.div`
  display: flex;
  justify-content: ${({ $justifyContent }) =>
    $justifyContent || 'space-between'};
  margin-top: ${Spacings.SPACING_10B};

  ${mediaQuery.uptoMobile} {
    flex-direction: column-reverse;
  }
`;

const Thumbnail = styled(Skeleton)`
  box-sizing: border-box;
  margin-right: ${Spacings.SPACING_8B};
  border-radius: ${Spacings.SPACING_2B};
  margin-bottom: ${Spacings.SPACING_2B};
  transform: scale(1);
`;

// eslint-disable-next-line react/jsx-props-no-spreading
const RectSkeleton = (props) => <Skeleton variant="rect" {...props} />;

const Language = styled(RectSkeleton)`
  margin-bottom: ${Spacings.SPACING_2B};
`;

const Title = styled(RectSkeleton)`
  margin-bottom: ${Spacings.SPACING_1B};
`;

const ShortDescription = styled(RectSkeleton)`
  margin-top: ${Spacings.SPACING_8B};
`;

const Description = styled.div`
  display: flex;
  flex-direction: column;
`;

const Header = () => {
  const isMobile = useIsMobile();

  return (
    <Container>
      {!isMobile && <Breadcrumbs title={false} breadcrumbsCount={4} />}
      <Flex>
        <Description>
          <Language width={80} height={30} />
          <Title width={300} height={20} />
          <ShortDescription width={isMobile ? '100%' : 420} height={60} />
        </Description>
        <Thumbnail width={isMobile ? '100%' : 360} height={180} />
      </Flex>
      <Flex $justifyContent="flex-start">
        <Actions />
      </Flex>
    </Container>
  );
};

export default Header;
